import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Modal, Button } from 'antd';
import { useHistory } from 'react-router-dom';

function ToBindTip({ visible = true, setVisible }) {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(visible);
  const toBind = () => {
    history.push('/saas-agent/platform?activeKey=account');
    setIsModalOpen(false);
    if (setVisible) {
      setVisible(false);
    }
  };
  useEffect(() => {
    setIsModalOpen(visible);
  }, [visible]);
  return (
    <>
      <Modal visible={isModalOpen} closable={false} footer={null} style={{ height: '500px' }}>
        <div style={{ textAlign: 'center' }}>
          <p style={{ height: '200px', lineHeight: '190px', fontSize: '18px', fontWeight: 'bold' }}>
            完成开户后才能进行后续操作
          </p>
          <Button onClick={toBind}>立即前往</Button>
        </div>
      </Modal>
    </>
  );
}
export default ToBindTip;
